/**
 * Anchor attribute that disables the hover link-preview card for one interlink.
 * Omitted / any other value → preview enabled (backward compatible).
 *
 * Note: the preview tooltip root also uses `data-interlink-preview=""` as a marker;
 * disabled anchors use the value `"0"` (or `"false"`).
 */
export const INTERLINK_PREVIEW_ATTR = "data-interlink-preview";
export const INTERLINK_PREVIEW_DISABLED_VALUE = "0";

/** True when an anchor opts out of hover link-preview. */
export function isInterlinkHoverPreviewDisabled(el: {
	getAttribute: (name: string) => string | null;
}): boolean {
	const value = el.getAttribute(INTERLINK_PREVIEW_ATTR)?.trim().toLowerCase();
	return value === INTERLINK_PREVIEW_DISABLED_VALUE || value === "false";
}

/** HTML attribute fragment when preview is disabled; empty string when enabled. */
export function interlinkPreviewDisabledAttrHtml(
	linkPreviewEnabled: boolean
): string {
	if (linkPreviewEnabled) {
		return "";
	}
	return ` ${INTERLINK_PREVIEW_ATTR}="${INTERLINK_PREVIEW_DISABLED_VALUE}"`;
}
